import { useEffect } from 'react'
import classNames from 'classnames'

import * as grs from 'grs'
import Select from 'shared/components/Select'
import { getTransactionStatuses } from 'shared/transactions'
import { withTranslate } from 'i18n/utils'

import { statusSelector, areAllVisibleSelector } from '../../selectors'
import { setStatusFilter, getReservations, getMoreReservations } from '../../actions'
import WaitingListTable from '../WaitingListTable'
import ReservationsTable from './ReservationsTable'

import styles from '../styles.module.scss'

const OPTION_LABEL_MAP = {
    [grs.constants.STATUS_ACTIVE]: 'dashboard.label.active',
    [grs.constants.STATUS_PASSED]: 'dashboard.label.passed',
    [grs.constants.STATUS_CANCELLED]: 'dashboard.label.cancelled',
    [grs.constants.STATUS_WAITING_LIST]: 'dashboard.label.waitingList',
}

const OPTIONS = getTransactionStatuses().map(value => ({
    value,
    label: <T>{OPTION_LABEL_MAP[value]}</T>,
}))

const Filters = ({ value, onChange, translate: t }) => (
    <div className="row justify-content-center align-items-center container">
        <div className={classNames('col-sm-auto', 'text-right', styles.reservationsSelectLabel)}>
            <T>dashboard.label.filterText</T>
        </div>
        <div className={classNames('col-sm-3', styles.reservationsSelect)}>
            <Select
                inputId="selectReservationOptions"
                ariaLabel={t('dashboard.label.combobox')}
                options={OPTIONS}
                value={OPTIONS.find(option => option.value === value)}
                onChange={onChange}
            />
        </div>
    </div>
)

const Reservations = ({
    getReservations,
    setStatusFilter,
    status,
    areAllVisible,
    onSelectReservation,
    getMoreReservations,
    translate: t,
}) => {
    useEffect(() => {
        getReservations()
    }, [])

    const onFilterChange = ({ value }) => {
        setStatusFilter(value)
    }

    return (
        <div>
            <Filters onChange={onFilterChange} value={status} translate={t} />

            {status === grs.constants.STATUS_WAITING_LIST ? (
                <WaitingListTable />
            ) : (
                <ReservationsTable onSelectReservation={onSelectReservation} />
            )}

            {!areAllVisible && (
                <div className={styles.showMore}>
                    <button className="btn  btn-outline-primary brand-button" onClick={getMoreReservations}>
                        <T>dashboard.label.show.more</T>
                    </button>
                </div>
            )}
        </div>
    )
}

const mapStateToProps = createStructuredSelector({
    status: statusSelector,
    areAllVisible: areAllVisibleSelector,
})

const mapDispatchToProps = {
    setStatusFilter,
    getReservations,
    getMoreReservations,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(Reservations))
